import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach bearer token if present (extra fallback for cookieless contexts)
api.interceptors.request.use((config) => {
  const t = localStorage.getItem("orio_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// Global 402 handler — the backend uses HTTP 402 for "ORIO Pro required"
// endpoints (Match, SOS, Missions create/join, Documents, SafeZones, Diary).
// We dispatch a global event so a single paywall modal can react anywhere in
// the app without every caller writing its own paywall.
//
// IMPORTANT (Play Store review fix, Aug 2026): the paywall MUST only fire on
// user-initiated actions (POST/PUT/PATCH/DELETE), never on background GET
// fetches. Home.jsx pings Pro-only lists like /match/matches on cold open —
// letting those spontaneously pop a paywall makes the app appear "locked"
// to Google reviewers before they can even see the UI, which is what got
// v18.9x rejected. GETs may still 402, callers handle their own empty
// state; only actions raise the paywall.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 402) {
      const method = (err?.config?.method || "get").toLowerCase();
      const isUserAction = method !== "get" && method !== "head";
      if (isUserAction && !err?.config?.skipGlobalPaywall) {
        try {
          const detail = err.response?.data?.detail || "Funzione riservata agli abbonati ORIO Pro";
          window.dispatchEvent(new CustomEvent("orio:pro-required", { detail }));
        } catch { /* ignore */ }
      }
    }
    return Promise.reject(err);
  }
);

export function formatErr(detail) {
  if (detail == null) return "Si è verificato un errore. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
